import { Side } from '../../types';

export const SIDES: Side[] = ['bottom', 'left', 'right', 'top'];
